const normalizeDomain = (domain, fallback) => {
  const value = domain || fallback;

  return value
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '')
    .replace(/:\d+$/, '');
};

const createDomainConfigs = () => {
  return [
    {
      domain: normalizeDomain(process.env.NEXT_PUBLIC_DOMAIN_EN, 'hoiango.com'),
      defaultLocale: 'en',
    },
    {
      domain: normalizeDomain(process.env.NEXT_PUBLIC_DOMAIN_VI, 'hoiango.vn'),
      defaultLocale: 'en',
    },
  ];
};

module.exports = {
  debug: process.env.NODE_ENV === 'development',
  // reloadOnPrerender: process.env.NODE_ENV === 'development',
  i18n: {
    locales: ['en', 'vi', 'ko'],
    defaultLocale: 'en',
    //domains: createDomainConfigs(),
    localeDetection: false,
  },
  localePath:
    typeof window === 'undefined'
      ? require('path').resolve('./public/locales')
      : '/locales',
  serializeConfig: false,
  cache: {
    enabled: true,
    expirationTime: 7 * 24 * 60 * 60 * 1000,
  },
};
